export default "__VITE_ASSET__Dffp8ucQ__"